<div id="block" *ngIf="progress.isVisible">
    <progress class="progress is-small is-link" max="100">15%</progress>
</div>
